import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Quote from '../views/Quote.vue'
import Gallery from '../views/Gallery.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
 
  {
    path: '/quote',
    name: 'Quote',
    component: Quote
    },    
    
   
    {
      path: '/gallery',
      name: "Gallery",
      component: Gallery
    }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
